import { z } from "zod";

const metadataSchema = z.record(z.string(), z.unknown()).nullable();

const importLogEntrySchema = z.object({
	source: z.string(),
	status: z.string(),
	message: z.string(),
	messageType: z.string(),
	metadata: metadataSchema,
});

export const importLogEntryPascalScehma = z.object({
	Source: z.string(),
	Status: z.string(),
	Message: z.string(),
	MessageType: z.string(),
	Metadata: metadataSchema,
});

export const importLogSchema = z.array(importLogEntrySchema);
